<template></template>
<script>
export default {
    data(){
        return{
        }
    },
    methods:{
        /**
        * Metodo que nos trae los datos para crear el toast
        * @author Victor Curilao
        **/
        makeToast(array) {
			this.$bvToast.toast(array.msg, {
				title: array.title,
				variant: array.variant,
				solid: true
			}) 
		}
    }
}
</script>